var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8047 4.02876C14.0651 4.28911 14.0651 4.71122 13.8047 4.97157L6.4714 12.3049C6.21106 12.5653 5.78894 12.5653 5.5286 12.3049L2.19526 8.97157C1.93491 8.71122 1.93491 8.28911 2.19526 8.02876C2.45561 7.76841 2.87772 7.76841 3.13807 8.02876L6 10.8907L12.8619 4.02876C13.1223 3.76841 13.5444 3.76841 13.8047 4.02876Z",
    fill: "#1B1918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.f553ce44add473a8587ce2857d9a8d88.svg";
export { ForwardRef as ReactComponent };